import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { GoogleMapsProvider } from './context/GoogleMapsContext';

const basename = window.location.pathname.startsWith('/dorm-dish') ? '/dorm-dish' : '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <GoogleMapsProvider>
        <App />
      </GoogleMapsProvider>
    </BrowserRouter>
  </React.StrictMode>
);
